import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import {
  Accordion,
  FilterAccordionHeader,
  Select,
} from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { required } from '../../../../../helpers/Validations';

function AddToCategory({ categories = [] }) {
  const [filterToggle, setFilterToggle] = useState(true);
  const intl = useIntl();

  const categoryOptions = categories.map(category => ({
    label: intl.formatMessage({
      id: `ui-reports.categories.name.${category.name}`,
      defaultMessage: category.name || '',
    }),
    value: category.id,
  }));

  return (
    <>
      <Accordion
        id="save-new-report-add-to-categories-accordion"
        label={
          <FormattedMessage
            id="ui-reports.newReport.saveReportPane.addToCategory.accordion.header"
            defaultMessage="Category"
          />
        }
        onToggle={() => setFilterToggle(!filterToggle)}
        open={filterToggle}
        separator
        header={FilterAccordionHeader}
      >
        <Field
          component={Select}
          label={
            <FormattedMessage
              id="ui-reports.newReport.saveReportPane.addToCategory.field.categoryName"
              defaultMessage="Category name"
            />
          }
          name="categories[0]"
          dataOptions={categoryOptions}
          placeholder={intl.formatMessage({
            id: 'ui-reports.newReport.saveReportPane.addToCategory.placeholder',
            defaultMessage: 'Select category'
          })}
          required
          validate={required}
        />
      </Accordion>
    </>
  );
}

AddToCategory.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
};

export default AddToCategory;
